import React from 'react'
import { Top } from '../../../styles'
import Coupons from './Coupons'
import PriceAndConditions from './PriceAndConditions'
import { ContainerTitleSecond, Title } from '../styles'

const Pricing = () => {
  return (
    <>
      <Top>
        <Title>Preço e condições</Title>
      </Top>
      <PriceAndConditions />
      <ContainerTitleSecond>
        <Title>Cupons</Title>
      </ContainerTitleSecond>
      <Coupons />
    </>
  )
}

export default Pricing
